import Grid, { GridProps } from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { GROUPED_LINKS_COLUMN_CLASSES } from "./constants";

export const GroupedLinksColumnContainer = styled(Grid)<GridProps>(({ theme }) => {
  const formatMedia = getFormatMedia(theme);

  return {
    [`& .${GROUPED_LINKS_COLUMN_CLASSES.headline}`]: {
      marginBottom: theme.spacing(4),
    },
    [`& .${GROUPED_LINKS_COLUMN_CLASSES.countrySelector}`]: {
      maxWidth: 240,
      display: "none",
      [formatMedia.BREAKPOINT_LARGE_DESKTOP]: {
        display: "flex",
      },
    },
  };
});
